// @flow
import * as React from 'react';

import BrightnessPicker from '../standard-brightness-picker';
import { BulbFlipperWrapper } from '../styles';
import DimmerMenu from './dimmer-menu';
import { MenuContainer } from '../menu';
import type { MenuInsertions } from '~/core/types';
import { noop } from 'lodash/fp';

type Props = {
    additionalMenuItems: MenuInsertions,
    bulbBrightness: number,
    isOn: boolean,
    isSaving?: boolean,
    isSmall?: boolean,
    isToggling?: boolean,
    toggleLightbulb: noop,
    valueChanged: noop
};

const WarmWhiteBulb = ({
    additionalMenuItems = [],
    bulbBrightness,
    isOn,
    isSaving,
    isSmall,
    isToggling,
    toggleLightbulb,
    valueChanged
}: Props) => {
    return (
        <BulbFlipperWrapper>
            <BrightnessPicker
                isOn={isOn}
                isSaving={isSaving}
                isSmall={isSmall}
                isToggling={isToggling}
                toggleLightbulb={toggleLightbulb}
                value={bulbBrightness}
                valueChanged={valueChanged}
            />
            <MenuContainer isSmall={isSmall}>
                <DimmerMenu additionalItems={additionalMenuItems} isOn={isOn} />
            </MenuContainer>
        </BulbFlipperWrapper>
    );
};

export default WarmWhiteBulb;



// WEBPACK FOOTER //
// ./src/components/bulbs/warm-white/index.js